// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__32OLz","selected":"Chip_selected__RV-vf"};